import { render, staticRenderFns } from "./riskAssessmentCategoryAction.vue?vue&type=template&id=53050424"
import script from "./riskAssessmentCategoryAction.vue?vue&type=script&lang=js"
export * from "./riskAssessmentCategoryAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports